module.exports = __webpack_public_path__ + "img/17.38aa1a10.png";